import React from 'react'
import './title.scss'

const Title = ({ txt, color }) => {
  return (
    <div className={'f-title-colegios ' + color}>
      {txt &&
      <h2>
        <span>{txt[0]}</span>
        <b>{txt[1]}</b>
        {txt[2] && <span> {txt[2]} </span>}
      </h2>
      }
    </div>
  )
}

export default Title
